<template>
  <div class="app-content-wrapper">
    <!-- <div class="top-wrapper">
      <div class="tab-box">
        <div v-for="item in tabList" :key="item.key" class="tab-item" :class="{active: curTabKey === item.key}" @click="handleTabItem(item.key)">
          {{$t(item.name)}}
        </div>
      </div>
    </div> -->
    <div class="table-top-box">
      <div class="table-top-operation">
        <el-button v-permission="'risk:list:add'" icon="el-icon-plus" size="small" @click="handleAdd">
          {{ $t('message.risk.addBlacklist') }}
        </el-button>
      </div>
      <!-- 新增黑名单提示 -->
      <common-info-description :customStyle="{ marginBottom: '24px' }" :text="$t('message.risk.addBlacklistTips')" />
    </div>
    <div class="table-wrapper">
      <custom-table ref="table" :table-set="tableCondition" :service-function="queryRiskList" router-name="/risk/list">
        <template #customOperations="{ row }">
          <el-popover placement="top" width="80" trigger="hover"
            :content="$t('message.risk.addBlackListItem.addItems')">
            <span v-permission="'risk:list:add'" class="add-button" @click="handleAddBackListItem(row)"
              slot="reference">
              <img class="icon-add" src="@/assets/image/common/icon-add.svg" alt="">
            </span>
          </el-popover>
        </template>
      </custom-table>
    </div>
    <validation-modal ref="validationModal" :titleText="modalTitleText" :showCancelButton="true"
      :default-function="addRiskLibName" :validation-condition="validationCondition" @refresh="onRefresh"
      :submitButtonText="modalTitleText">
      <template>
        <custom-radio v-model="productType" :options="RULE_PRODUCT_TYPE_OPTIONS" :value-key="'value'"
          @change="handleProductTypeChange" :label-key="'label'" :desc-key="'desc'"
          :label="$t('message.risk.addBlacklistdialog.applyTo')"
          :info-tips="$t('message.risk.addBlacklistdialog.applyToTips')" show-info-tips />
      </template>
    </validation-modal>
    <custom-message ref="customMessage"></custom-message>
    <validate-drawer ref="validationDrawer" :withHeader="false"
      :titleText="$t('message.risk.addBlackListItem.addItemsToBlacklist')"
      :submitButtonText="$t('message.risk.addBlackListItem.addItems')" :showCancelButton="true"
      :default-function="addInfo" @refresh="onRefresh">
      <template #prefix>
        <oner-tab :tabs="TAB_LIST" v-model="curTabKey" />
        <add-black-list-item-single ref="addBlackListItemSingle" v-if="curTabKey === 'MANUAL_INPUT'"
          :lib-info="addBlackListItemParams" />
        <add-black-list-item-batch :lib-info="addBlackListItemParams" ref="addBlackListItemBatch"
          v-if="curTabKey === 'UPLOAD_CSV'" />
      </template>
    </validate-drawer>

  </div>
</template>
<script>
import CommonInfoDescription from '@/components/common/common-info-description/index.vue';
import CustomRadio from '@/components/common/form/custom-radio.vue';
import ValidateDrawer from '@/components/modal/base-modal/validate-drawer.vue';
import ValidationModal from '@/components/modal/base-modal/validation-modal.vue';
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import { ShowErrorMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import { REQUIRED } from '@/components/validation/tool/validator';
import OnerTab from '@/componentsV2/base-cmps/tab/index.vue';
import { IS_PERMISSION_BUTTON } from '@/store/modules/permission';
import { getEnantiomericValue } from '@/utils/tools/constant';
import { shallowClones } from '@/utils/tools/utils.js';
import { RISK_DECISION, RISK_FACTOR, RULE_PRODUCT_TYPE_OPTIONS, TAB_LIST } from '@/views/risk/api/options';
import {
  queryRiskList, updateRiskLibRuleStatus, addRiskLibName,
  updateRiskLibRuleName,
  batchAddRiskLibDetail, manualBatchAddByServiceIds, manualBatchAddByValues,
} from '@/views/risk/api/risk';
import AddBlackListItemBatch from '@/views/risk/components/add-blackList-item/batch.vue';
import AddBlackListItemSingle from '@/views/risk/components/add-blackList-item/single.vue';

export default {
  components: {
    CustomTable,
    ValidationModal,
    CustomMessage,
    CommonInfoDescription,
    CustomRadio,
    ValidateDrawer,
    OnerTab,
    AddBlackListItemSingle,
    AddBlackListItemBatch,
  },
  data() {
    return {
      curTabKey: '',
      TAB_LIST,
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.risk.listName' },
          key: 'riskListName',
          type: 'click',
          subTableDisplays: [
            {
              type: 'link',
              key: 'riskListName',
              router: '/risk/detail',
              isInternationalization: true,
              valueKey: ['riskLibraryId', 'riskListName', 'type', 'createOpr', 'updateTime', 'remarks', 'riskLibraryName', 'status', 'productType'],
              paramsKey: ['riskLibraryId', 'riskListName', 'type', 'createOpr', 'updateTime', 'riskDecision', 'riskLibraryName', '_status', 'productType'],
              isDisplayFunc: () => this.isHasViewAuth(),
            },
            {
              type: 'text',
              key: 'riskListName',
              isDisplayFunc: () => !this.isHasViewAuth(),
            },
          ],
        },
        // 过去30天命中次数
        {
          titleBar: { type: 'text', title: 'message.risk.hitCount30Day', tooltipContent: 'message.risk.hitCount30Day' },
          key: 'hitCount',
          type: 'text',
          align: 'right',
          // itemStyle: () => {
          //   return 'width: 50px !important;';
          // },
          textFunc: (data) => {
            // 千分位处理
            return data.hitCount ? data.hitCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0';
          },
          // showTooltip: true,
        },
        // 命中率
        // ≥10%：高效黑名单，行业平均有效黑名单命中率为5-15%，超过10%属于高效规则 字体色值#F53F3F  背景色#FEF3F2
        // 2-10%：正常有效的黑名单规则，Stripe和Adyen等平台数据显示，大多数有效黑名单命中率在这一区间 字体色值#F59E0B  背景色#FFEBD6
        // <2%：低效黑名单，需要关注并可能优化，低于2%的命中率通常表示规则可能过于宽松或已不再适用 字体色值#00B42A  背景色#ECFDF3
        {
          titleBar: { type: 'text', title: 'message.risk.hitRate30Day', tooltipContent: 'message.risk.hitRate30Day' },
          key: 'hitRate',
          type: 'text',
          itemStyle: (data) => {
            const rate = Number(data.hitRate).toFixed(2);
            const rateNum = parseFloat(rate);
            let style = '';
            if (rateNum >= 0.1) {
              // ≥10%：高效黑名单
              style = 'color: #F53F3F; background-color: #FEF3F2; padding: 2px 8px; border-radius: 4px;';
            } else if (rateNum >= 0.02) {
              // 2-10%：正常有效的黑名单规则
              style = 'color: #FF8000; background-color: #FFEBD6; padding: 2px 8px; border-radius: 4px;';
            } else {
              // <2%：低效黑名单
              style = 'color: #00B42A; background-color: #ECFDF3; padding: 2px 8px; border-radius: 4px;';
            }
            return style + 'border-radius: 20px;min-width: 43px;height: 22px;line-height: 22px;font-size: 12px;font-family: Open Sans-Regular;display: flex;align-items: center;justify-content: center;';
          },
          textFunc: data => data.hitRate ? `${(Number(data.hitRate) * 100).toFixed(2)}%` : '0%',
          showTooltip: true,
        },
        {
          titleBar: { type: 'text', title: 'message.risk.listType', tooltipContent: 'message.risk.listType' },
          key: 'type',
          type: 'text',
          textFunc: data => this.$t(getEnantiomericValue(RISK_FACTOR, data.type)),
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.status' },
          key: 'status',
          type: 'status',
          textFunc: data => +data.status === 1 ? 'message.common.disable' : 'message.common.enable',
          isInternationalization: true,
        },
        // https://confluence.ronhan.com/confluence/pages/viewpage.action?pageId=60897702 需求移除此列
        // {
        //   titleBar: { type: 'text', title: 'message.risk.attribute' },
        //   key: 'remarks',
        //   type: 'text',
        //   textFunc: data => this.$t(getEnantiomericValue(RISK_DECISION, data.remarks)),
        // },
        {
          titleBar: { type: 'text', title: 'message.risk.dataCount' },
          key: 'total',
          type: 'click',
          align: 'right',
          subTableDisplays: [
            {
              type: 'link',
              key: 'total',
              router: '/risk/detail',
              isInternationalization: true,
              valueKey: ['riskLibraryId', 'riskListName', 'type', 'createOpr', 'updateTime', 'remarks', 'riskLibraryName', 'status', 'productType'],
              paramsKey: ['riskLibraryId', 'riskListName', 'type', 'createOpr', 'updateTime', 'riskDecision', 'riskLibraryName', '_status', 'productType'],
              isDisplayFunc: () => this.isHasViewAuth(),
            },
            {
              type: 'text',
              key: 'total',
              isDisplayFunc: () => !this.isHasViewAuth(),
            },
          ],
        },
        {
          titleBar: { type: 'text', title: 'message.risk.addBlacklistdialog.applyTo' },
          key: 'productType',
          type: 'text',
          textFunc: data => {
            if (!data.productType) {
              return this.$t('message.tableCommon.card');
            }
            return this.$t(getEnantiomericValue(RULE_PRODUCT_TYPE_OPTIONS, data.productType));
          },
        },

        {
          titleBar: { type: 'text', title: 'message.risk.addBy' },
          key: 'createOpr',
          type: 'text',
        },

        {
          titleBar: { type: 'text', title: 'message.risk.lastModifiedDate' },
          key: 'updateTime',
          type: 'text',
        },
        {
          key: 'buttons',
          titleBar: { title: 'message.tableCommon.operation', type: 'operations' },
          type: 'operations',
          itemMinWidth: 120,
          subTableDisplays: [
            {
              type: 'text_button',
              textFunc: () => 'message.common.edit',
              permissionCode: 'risk:list:edit',
              func: async data => {
                this.modalTitleText = this.$t('message.risk.addBlacklistdialog.editTitle');
                this.$refs.validationModal.openModalAndCallBack(form => {
                  form.setItemDisabled('type', true);
                  const productType = data.productType || 'CARD';
                  form.assignmentFormValue({ ...data, riskDecision: data.remarks, productType });
                  let list = RULE_PRODUCT_TYPE_OPTIONS;
                  if (data.type !== 'EMAIL') {
                    list = RULE_PRODUCT_TYPE_OPTIONS.filter(item => item.value === 'CARD');
                  }
                  this.RULE_PRODUCT_TYPE_OPTIONS = shallowClones(list);
                  // form.setValidationSelectOptions('productType', shallowClones(list));
                  this.$refs.validationModal.setModifyCondition({
                    id: data.id,
                  }, updateRiskLibRuleName);
                });
              },
            },
            {
              type: 'text_button',
              textFunc: data => +data.status === 1 ? 'message.common.enableOperationText' : 'message.common.disableOperationText',
              permissionCode: 'risk:list:editStatus',
              func: async data => {
                this.$refs.customMessage.openHttpModal({
                  contentHtml: this.$t('message.risk.confirmTip', { operate: (+data.status === 1) ? this.$t('message.common.enableOperation').toLowerCase() : this.$t('message.common.disableOperation').toLowerCase() }),
                  titleHtml: this.$t('message.common.prompt'),
                  httpFunction: updateRiskLibRuleStatus,
                  params: {
                    riskLibraryId: data.riskLibraryId,
                    applyRule: +data.status === 1,
                    riskDecision: data.remarks,
                    riskLibraryName: data.riskLibraryName,
                    type: data.type,
                  },
                  successFunction: this.onRefresh,
                }, '');
              },
            },
            // {
            //   type: 'text_button',
            //   textFunc: () => 'message.tableCommon.details',
            //   permissionCode: 'risk:detail',
            //   func: async data => {
            //     this.$router.push({
            //       path: '/risk/detail',
            //       query: {
            //         riskLibraryId: data.riskLibraryId,
            //         // riskListName: data.riskListName,
            //         riskListName: data.riskListName,
            //         type: data.type,
            //         createOpr: data.createOpr,
            //         updateTime: data.updateTime,
            //         riskDecision: data.remarks,
            //         riskLibraryName: data.riskLibraryName,
            //         _status: data.status,
            //         productType: data.productType,
            //       },
            //     });
            //   },
            // },
          ],
        },
      ],
      modalTitleText: '',
      validationCondition: [
        {
          key: 'riskListName',
          name: 'message.risk.addBlacklistdialog.blacklistName',
          type: 'input',
          defValue: '',
          isShowStar: true,
          rule: [REQUIRED],
        },
        // https://confluence.ronhan.com/confluence/pages/viewpage.action?pageId=60897702需求去除
        {
          key: 'riskDecision',
          name: 'message.risk.listAttribute',
          type: 'hidden',
          defValue: 'BLACKLIST',
          isShowStar: true,
          rule: [REQUIRED],
          options: RISK_DECISION,
          isInternationalization: true,
        },
        {
          key: 'type',
          name: 'message.risk.addBlacklistdialog.blacklistType',
          type: 'select',
          defValue: 'EMAIL',
          isShowStar: true,
          rule: [REQUIRED],
          options: RISK_FACTOR,
          isInternationalization: true,
          changeValue: value => {
            this.productType = 'CARD';
            // 黑名单类型变化的时候 产品类型默认设置为卡支付
            this.$refs.validationModal.getForm().setItemValue('productType', 'CARD');
            let list = RULE_PRODUCT_TYPE_OPTIONS;
            if (value !== 'EMAIL') {
              list = RULE_PRODUCT_TYPE_OPTIONS.filter(item => item.value === 'CARD');
            }
            this.RULE_PRODUCT_TYPE_OPTIONS = shallowClones(list);
          },
        },
        // {
        //   key: 'productType',
        //   name: 'message.risk.scope',
        //   type: 'select',
        //   defValue: '',
        //   isShowStar: true,
        //   rule: [REQUIRED],
        //   options: shallowClones(RULE_PRODUCT_TYPE_OPTIONS),
        //   isInternationalization: true,
        // },
        {
          key: 'productType',
          name: '',
          type: 'slot',
          defValue: '',
          isShowStar: true,
          rule: [],
          isInternationalization: true,
        },
      ],
      // 作用范围
      productType: 'CARD',
      RULE_PRODUCT_TYPE_OPTIONS,
      failFileUrl: '',
      addBlackListItemParams: {},
      libInfo: {
        type: 'EMAIL',
      },
    };
  },
  mounted() {
    // 初始化设置默认值
    if (this.$refs.validationModal?.getForm()) {
      this.$refs.validationModal.getForm().setItemValue('productType', 'CARD');
    }
  },
  methods: {
    queryRiskList,
    addRiskLibName,
    onRefresh() {
      this.$refs.table.refreshTable();
    },
    handleTabItem(key) {
      if (this.curTabKey === key) {
        return;
      }
      this.curTabKey = key;
    },
    handleAdd() {
      this.modalTitleText = this.$t('message.risk.addBlacklistdialog.addTitle');
      this.productType = 'CARD';
      this.RULE_PRODUCT_TYPE_OPTIONS = shallowClones(RULE_PRODUCT_TYPE_OPTIONS);
      this.$refs.validationModal.openModalAndCallBack(form => {
        form.setItemDisabled('type', false);
      });
    },
    isHasViewAuth() {
      return this.$store.getters[IS_PERMISSION_BUTTON]('risk:detail');
    },
    handleProductTypeChange(value) {
      this.$refs.validationModal.$refs.validationForm.setItemValue('productType', value);
    },
    handleAddBackListItem(row) {
      this.addBlackListItemParams = row.status.itemData;
      this.$refs.validationDrawer.openDrawerAndCallBack();
    },
    async addInfo() {
      let data;
      let errMsg;
      const { riskLibraryId, type, riskLibraryName } = this.addBlackListItemParams;
      if (this.curTabKey === 'MANUAL_INPUT') {
        try {
          const validateResult = await this.$refs.addBlackListItemSingle.toFormValid();
          if (!validateResult.valid) {
            return Promise.reject(this.$t('message.common.formDataError'));
          }
          const formData = validateResult.formData;
          if (!formData) {
            return Promise.reject(new Error(this.$t('message.common.formDataError')));
          }
          // Split values by newlines and filter out empty lines
          const values = formData.values.split('\n');
          this.addBlackListItemParams = {
            values,
            riskLibraryId,
            serviceIds: values,
            type,
            status: formData.status,
            riskLibraryName,
            expirationTime: formData.expirationTime,
            addOneType: formData.addOneType ? 'byServiceId' : 'byCardNumber',
          };
          if (formData.addOneType) {
            await manualBatchAddByServiceIds(this.addBlackListItemParams);
          } else {
            await manualBatchAddByValues(this.addBlackListItemParams);
          }
        } catch (error) {
          ShowErrorMessage(error.message || this.$t('message.submitFailedTip'));
        }
      } else {
        if (this.failFileUrl) { // 若失败文件存在则下载
          window.location.href = this.failFileUrl;
        }
        const item2File = this.$refs.addBlackListItemBatch?.getFormJson()?.item2File;
        if (!item2File) {
          errMsg = this.$t('message.common.uploadFile');
          ShowErrorMessage(errMsg);
          return Promise.reject(new Error(errMsg));
        }

        data = new FormData();
        data.append('file', item2File);
        data.append('riskLibraryId', riskLibraryId);
        data.append('type', type);
        data.append('riskLibraryName', riskLibraryName);
        const res = await batchAddRiskLibDetail(data);
        if (res) {
          this.failFileUrl = res;
          this.submitErrorMessage = this.$t('message.risk.batchFileError');
          ShowErrorMessage(this.submitErrorMessage);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.top-wrapper {
  margin-bottom: 25px;

  .tab-box {
    border-bottom: 1px solid $color-text-default-button;

    .tab-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 114px;
      height: 35px;
      background: $color-default;
      border-radius: 15px 15px 0px 0px;
      cursor: pointer;
      color: $color-text-default-button;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      font-size: 14px;

      &.active {
        background: $color-text-default-button;
        color: white;
      }
    }
  }
}

.table-top-box {
  display: flex;
  align-items: center;
  font-family: PingFang-SC-Bold, PingFang-SC;
  color: $color-text-primary;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;

  .table-top-operation {
    // 右对齐
    display: flex;
    justify-content: flex-end;
    flex: 1;
    flex-basis: 100%;
    width: 100%;
  }

  .table-top-tips {
    flex: 1;
    flex-basis: 100%;
    width: 100%;
    background: #F9FAFB;
    border-radius: 8px 8px 8px 8px;
    margin-top: 32px;
    padding: 16px 24px;
    font-weight: 400;
    font-size: 16px;
    color: #1A202C;

    .icon-daohanglantishiicon {
      margin-right: 8px;
    }
  }

}

.table-wrapper {
  .add-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 26px;
    background: $color-text-default-button;
    border-radius: 8px;
    cursor: pointer;
    margin-right: 4px;
    padding: 4px 8px;

    .icon-add {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
<style lang="scss">
.el-popover {
  border: none;
  box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.05);
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  background: #000;
  padding: 8px !important;
  text-align: center;
  min-width: auto !important;

  .popper__arrow {
    border-top-color: #000 !important;

    &::after {
      border-top-color: #000 !important;
    }
  }
}
</style>
